module.exports = __webpack_public_path__ + "static/media/Basal_4422.af70221a.jpg";